module.exports = __webpack_public_path__ + "static/musa-sun-db817fe8fdd21d50f379caebc8fcb337.png";